// assets/widget-resize.js
(function () {
  const apply = (el) => {
    el.style.setProperty('height', '56px', 'important');
    el.style.setProperty('min-height', '56px', 'important');
    el.style.setProperty('padding', '14px 18px', 'important');
    el.style.setProperty('font-size', '18px', 'important');
    el.style.setProperty('line-height', '1.25', 'important');
    el.style.setProperty('border-radius', '12px', 'important');
    el.style.setProperty('box-sizing', 'border-box', 'important');
    // Stretch full width when possible
    const wrapper = el.closest('.pe-field, .pe-control, .field, .input');
    if (wrapper) wrapper.style.setProperty('max-width', '100%', 'important');
  };

  const SELECTORS = [
    // Very generic fallbacks
    'input[placeholder*="date" i]',
    'input[placeholder*="time" i]',
    // Common Pickeasy field hooks
    '.pe-widget input',
    '.pe-widget select',
    '.pe-widget .pe-input input',
    '.pe-widget .pe-select select',
  ].join(',');

  function resize() {
    // If the widget is inside an iframe, we can't touch it from theme code
    const ifr = document.querySelector('.pe-widget iframe');
    if (ifr) {
      console.warn('Delivery widget is inside an iframe; styling must be changed in the app settings.');
      return;
    }
    document.querySelectorAll(SELECTORS).forEach(apply);
  }

  // Run now and whenever DOM changes (apps re-render)
  document.addEventListener('DOMContentLoaded', resize);
  const mo = new MutationObserver(resize);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
